<template>
      <div class="list">
        <div class="list-item list-header">Messages</div>
        <div
          class="list-item"
          v-for="msg in messages"
          :class="{ read: msg.read }"
          :key="msg.uid"
        >
          <Message :msg="msg" />
        </div>
      </div>
    </template>

    <script>
    import settings from '@/settings.coffee'
    import Message from '@/components/Message'
    import ALERT_SET from '@/gql/queries/alertSet.graphql'
    import { gqlQuery } from '@/gqlClient.js'

    export default {
      name: "MessagesList",
      components: { Message },
      props: {},
      data() {
        return {
          messages: []
        }
      },
      async mounted() {
        const res = await gqlQuery(ALERT_SET, { to_uid: this.$store.state.profile.data.uid });
        this.messages = res.body.data.alert_set || [];
      }
    }
    </script>

    <style lang="scss" scoped>
    .list-header {
      padding: 10px;
      font-weight: bold;
    }
    .read {
      background: #EEE;
    }
    </style>